// src/admin/AdminDashboard.js
import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AdminHome from "./AdminHome";
import { useContext } from "react";
import { AdminLanguageContext } from "./context/AdminLanguageContext";

function AdminDashboard() {
  const { lang } = useContext(AdminLanguageContext);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`bg-gray-100 min-h-screen ${lang === "AR" ? "lg:pr-[240px]" : "lg:pl-[240px]"}`}>

      {/* HEADER */}
      <AdminHeader setIsOpen={setIsOpen} />

      <div className="flex">

        {/* SIDEBAR */}
        <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

        {/* CONTENT */}
        <div className="flex-1 bg-[#f1f1f1]">
          <AdminHome />
        </div>

      </div>
    </div>
  );
}

export default AdminDashboard;